import React, { useState } from "react";
import { Table as AntdTable } from "antd";
import SampleModal from "./sample-modal-table";

// Sample data
const dataSource = [
  {
    key: "1",
    id: 1,
    name: "Pushkar Chaubey",
    age: 23,
    address: "Gorakhpur, India",
  },
  {
    key: "2",
    id: 2,
    name: "Ravi Kumar",
    age: 28,
    address: "Lucknow, India",
  },
];

// Define columns
const Table = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#sampleModal"
            onClick={() => setSelectedUser(record)}
          >
            Open
          </button>
        );
      },
    },
  ];

  return (
    <>
      <div className="p-3 bg-white rounded shadow-sm">
        <h5 className="mb-3">User Table</h5>
        <AntdTable
          dataSource={dataSource}
          columns={columns}
          pagination={{ pageSize: 5 }}
          scroll={{ x: 500 }}
        />
      </div>
      <SampleModal selectedUser={selectedUser} />
    </>
  );
};

export default Table;
